import { useI18n } from "@garther/ui/libs";
import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { OrgLocation } from "../-components/org-location";

export const Route = createFileRoute("/_auth/org/$orgId/locations/")({
  component: RouteComponent
});

function RouteComponent() {
  const { t } = useI18n();
  const { org } = useRouteContext({ from: "/_auth/org/$orgId/locations/" });

  return (
    <div className="py-4 md:py-6 space-y-4">
      <p className="text-responsive-xl font-light text-text-primary uppercase font-literata">
        {t("org.tabs.locations")}
      </p>
      <OrgLocation org={org} />
    </div>
  );
}
